// FAQ content for Paranormal Archetypes.
// Placeholder questions & answers, the owner will replace these with final
// approved copy. Each item renders on the in-app FAQ screen. Answers support the
// same simple formatting as the legal pages (headings, bullets, paragraphs).

export const FAQ_LAST_UPDATED = 'June 2026'; // TODO: set to the official launch month/year
export const FAQ_CONTACT_EMAIL = 'Info@ParanormalArchetypes.net';

export const FAQ_INTRO =
  'Answers to common questions about Paranormal Archetypes. Tap any question to read more.';

// Final approved FAQ content. Batches appended as provided by the owner.
export const FAQ_ITEMS = [
  {
    key: 'what-is',
    question: 'What is Paranormal Archetypes?',
    answer: `Paranormal Archetypes is a research based framework designed to help individuals recognize patterns in how they naturally observe, process, and engage with paranormal experiences. Rather than focusing only on the phenomena itself, Paranormal Archetypes explores the role of the investigator and how different perspectives can contribute to a deeper understanding of the unknown.`,
  },
  {
    key: 'vs-personality',
    question: 'How is Paranormal Archetypes different from a personality assessment?',
    answer: `Paranormal Archetypes is not a personality assessment. It does not measure personality traits, intelligence, beliefs, or abilities. Instead, it focuses on how you naturally recognize, interpret, and contribute information during paranormal experiences and investigations.`,
  },
  {
    key: 'how-assessment-works',
    question: 'How does the assessment work?',
    answer: `The assessment consists of 54 questions designed to identify patterns in how you naturally approach paranormal experiences. Your responses are evaluated across the nine Paranormal Archetypes to determine the perspective you most naturally bring to the field.`,
  },
  {
    key: 'primary-secondary',
    question: 'Why do I receive a Primary and Secondary archetype?',
    answer: `Your Primary archetype represents the perspective that appears most consistently in your assessment. Your Secondary archetype provides additional context by showing another natural influence that supports or complements your Primary archetype. Together, they offer a more complete picture of how you approach the unknown.`,
  },
  {
    key: 'will-change',
    question: 'Will my archetype ever change?',
    answer: `Your archetype reflects your natural perspective rather than your experience level or current interests. While knowledge, confidence, and skills may grow over time, your underlying perspective is generally expected to remain consistent. As you continue observing, reflecting, and gaining experience, you'll often discover new ways your archetypes are expressed rather than becoming a different archetype.`,
  },
  {
    key: 'retake',
    question: 'Can I retake the assessment?',
    answer: `The assessment is designed as a one-time experience. Your results represent your natural perspective rather than your current knowledge or experience. Instead of retaking the assessment, we encourage you to continue observing, reflecting, and recognizing how your archetypes appear over time.`,
  },
  {
    key: 'whats-included',
    question: "What's included with my purchase?",
    answer: `Your purchase includes the product or products you selected. Depending on your purchase, you may receive access to the assessment, Starter Kit, Manual, Guidebook, or the Complete Bundle. Each product is designed to build upon the others while also providing value on its own.`,
  },
  {
    key: 'product-differences',
    question: "What's the difference between the Starter Kit, Manual, and Guidebook?",
    answer: `Each product serves a different purpose. The Starter Kit introduces the framework and helps you begin applying your archetypes. The Manual provides a concise reference with practical tools and exercises. The Guidebook offers the most in-depth exploration of the framework, expanding on concepts, perspectives, and applications in greater detail.`,
  },
  {
    key: 'access-codes',
    question: 'How do access codes work?',
    answer: `Access codes unlock the products associated with your purchase. Simply sign in to your account, enter your access code, and the corresponding content will be added to your Library. Each code is intended for a single redemption unless otherwise specified.`,
  },
  {
    key: 'purchase-later',
    question: 'Can I purchase additional products later?',
    answer: `Yes. You can expand your Library at any time by purchasing additional Paranormal Archetypes products as they become available. Any new purchases will be added to your account, allowing you to continue building your understanding of the framework at your own pace.`,
  },
  {
    key: 'privacy',
    question: 'Is my information private?',
    answer: `Yes. Your account information and assessment results are associated with your account and are intended for your personal use within the Paranormal Archetypes platform. Please refer to our Privacy Policy for complete details regarding how information is collected, used, and protected.`,
  },
  {
    key: 'contact-support',
    question: 'How do I contact support?',
    answer: `If you have questions or need assistance, please contact us at Info@ParanormalArchetypes.net. We'll be happy to help.`,
  },
  {
    key: 'explain-prove',
    question: 'Does Paranormal Archetypes explain or prove paranormal experiences?',
    answer: `No. Paranormal Archetypes is not designed to prove, disprove, or explain paranormal phenomena. Instead, it provides a framework for recognizing patterns in how individuals naturally observe, process, and engage with paranormal experiences. The goal is not to provide definitive answers about the unknown, but to encourage observation, reflection, discussion, and continued learning.`,
  },
];
